import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';

import {FULFILLMENT_STATUS_NAMES, FulfillmentStatus} from './FulfillmentConstants';
import {getIconAndClassNameForStatus} from './FulfillmentStatus';

interface FulfillmentStatusFilterDropdownProps {
  statusOptions: Array<FulfillmentStatus>;
  value: FulfillmentStatus | null;
  onSelect: (status: FulfillmentStatus) => void;
}

export default function FulfillmentStatusFilterDropdown(
  props: FulfillmentStatusFilterDropdownProps
): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM} value={props.value}>
          <Section>
            <Option
              value={null}
              icon="notdef"
              iconClassName={css(styles.blankIcon)}
              onSelect={props.onSelect}
            >
              All
            </Option>
          </Section>
          <Section>
            {props.statusOptions.map((status) => {
              const {icon, className} = getIconAndClassNameForStatus(status);
              return (
                <Option
                  key={status}
                  value={status}
                  icon={icon}
                  iconClassName={className}
                  onSelect={props.onSelect}
                >
                  {FULFILLMENT_STATUS_NAMES[status]}
                </Option>
              );
            })}
          </Section>
        </Menu>
      }
    >
      <Button buttonStyle={ButtonStyle.CIRCLE_ICON} icon="filter" size={ButtonSize.SMALL} isDropdown={true} />
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  blankIcon: {
    color: 'transparent',
  },
});
